module.exports = __webpack_public_path__ + "img/model_01.b6a42b04.png";